import FModal from './FModal'
import Formation from './Formation'
import FSelect from './FSelect'
import FTabs from './FTabs'
import ThemeSelector from './ThemeSelector'
import Hello from './Hello'

export { FModal }
export { Formation }
export { FSelect }
export { FTabs }
export { ThemeSelector }
export { Hello }

export default {
  FModal,
  Formation,
  FSelect,
  FTabs,
  ThemeSelector,
  Hello
}



/** WEBPACK FOOTER **
 ** ./src/components/index.js
 **/